import BreadCrumbs from '@components/breadcrumbs/Breadcrumbs'
import mix from '@utils/styles/mix'

import styles from '@components/blog/styles/PageContainer.module.css'

function PageContainer ({ hero, html, children, sidebar }) {
    return (
        <section>
            { hero }

            <section className={mix([styles.crumbs, 'container'])}>
                <BreadCrumbs skip={['kategoria', 'tagi', 'data', 'wpis']} />
            </section>

            { html }

            <section className={mix([styles.main, 'container'])}>
                <div className={styles.content}>
                    { children }
                </div>
                <div className={styles.sidebar}>
                    { sidebar }
                </div>
            </section>
        </section>
    )
}

export default PageContainer